import styled from '@emotion/styled'

export const StyledDetailStatistic = styled.div`
  display: flex;
  gap: 32px;
`
